export default function VenueAccess() {
  return (
    <div className="fairy-card">
      <h3 className="text-3xl md:text-4xl font-dancing mb-6 text-center text-gray-800">
        Access
      </h3>

      <div className="space-y-6 text-primary-500">
        <div className="text-center space-y-2">
          <p className="[&_span]:inline-block text-xl font-bold font-fairy text-gray-800">
            <span className="sr-only">
              琉球ホテル＆リゾート 名城ビーチ ウエディング
            </span>
            <span aria-hidden="true">
            <a
              href="https://ryukyuhotel.kenhotels.com/access/#car"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="text-blue-600 hover:text-blue-800 underline decoration-2 transition-colors">琉球ホテル＆リゾート</span>
              <span className="text-blue-600 hover:text-blue-800 underline decoration-2 transition-colors">名城ビーチ ウエディング</span>
            </a>
            </span>
          </p>

          <p className="text-gray-600">
            〒901-0351 沖縄県糸満市名城９６３
          </p>

          <p className="[&_span]:inline-block text-gray-600">
            <span className="sr-only">空港から車で約30分</span>
            <span aria-hidden="true">
              <span>空港から車で約30分</span>
              <span>タクシーのご利用料金の目安は</span>
              <span>約4,000円～でございます。</span>
            </span>
          </p>

          <p className="[&_span]:inline-block text-gray-600 [&_span]:leading-none">
            <span className="sr-only">※車種や混雑状況によって、料金が異なる場合がございます。</span>
            <span aria-hidden="true">
              <span className="text-xs">※車種や</span>
              <span className="text-xs">混雑状況によって、</span>
              <span className="text-xs">料金が</span>
              <span className="text-xs">異なる場合が</span>
              <span className="text-xs">ございます。</span>
            </span>
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-lg h-96">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3579.6483015041574!2d127.65665517544893!3d26.101152977151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34e567f93bdde457%3A0x7783af70015c089d!2z55CJ55CD44Ob44OG44Or77yG44Oq44K-44O844OIIOWQjeWfjuODk-ODvOODgSDjgqbjgqjjg4fjgqPjg7PjgrA!5e0!3m2!1sja!2sjp!4v1736056285584!5m2!1sja!2sjp"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="flex justify-center gap-4">
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=琉球ホテル＆リゾート名城ビーチ+ウエディング&travelmode=driving"
            target="_blank"
            rel="noopener noreferrer"
            className="fairy-button [&_span]:inline-block text-center"
          >
            <span className="sr-only">現在地からの経路を確認</span>
            <span aria-hidden="true">
              <span>現在地からの</span>
              <span>経路を確認</span>
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}
